export const tr = {
    common: {
        cancel: 'İptal',
        save: 'Kaydet',
        delete: 'Sil',
        edit: 'Düzenle',
        create: 'Oluştur',
        loading: 'Yükleniyor…',
        copy: 'Kopyala',
        ok: 'Tamam',
        close: 'Kapat',
        or: 'veya',
        creating: 'Oluşturuluyor...',
        unknownError: 'Bilinmeyen hata',
        none: 'Yok',
        color: 'Renk',
        visible: 'Görünür',
        locked: 'Kilitli',
        hide: 'Gizle',
        show: 'Göster',
        lock: 'Kilitle',
        unlock: 'Kilidi Aç',
        update: 'Güncelle',
    },
    language: {
        label: 'Dil',
    },
    auth: {
        welcome: 'tween.studio’ya hoş geldiniz — hareket tasarlayın, sahneler oluşturun ve hikayelerinizi hayata geçirin.',
        email: 'E-posta',
        password: 'Şifre',
        emailPlaceholder: 'ornek@eposta.com',
        name: 'Ad',
        surname: 'Soyad',
        namePlaceholder: 'Ada',
        surnamePlaceholder: 'Lovelace',
        confirmPassword: 'Şifreyi Onayla',
        termsOfService: 'Kullanım Koşulları',
        privacyPolicy: 'Gizlilik Politikası',
        and: 've',
        signInTitle: 'Giriş Yap',
        signInSubtitle: 'Kaldığınız yerden devam edin.',
        signIn: 'Giriş Yap',
        signingIn: 'Giriş yapılıyor...',
        noAccount: 'Hesabınız yok mu?',
        signUp: 'Kayıt ol',
        loginFailed: 'Giriş başarısız',
        googleSignInFailed: 'Google ile giriş başarısız',
        googleSignInLoadFailed: 'Google ile giriş yüklenemedi',
        continueWithFacebook: 'Facebook ile devam et',
        continueWithInstagram: 'Instagram ile devam et',
        metaSignInComingSoon: '{brand} girişi Meta Login kullanır — bağlantı yakında. Sağlayıcı admin’den yapılandırılabilir.',
        createAccountTitle: 'Hesap Oluştur',
        createAccountSubtitle: 'tween.studio’ya katılın ve animasyona başlayın.',
        createAccount: 'Hesap Oluştur',
        creatingAccount: 'Hesap oluşturuluyor...',
        hasAccount: 'Zaten hesabınız var mı?',
        signInLink: 'Giriş yap',
        termsAgreePrefix: 'Hesap oluşturarak',
        termsAgreeSuffix: ' kabul etmiş olursunuz.',
        passwordMinLength: 'Şifre en az 6 karakter olmalıdır.',
        passwordsDoNotMatch: 'Şifreler eşleşmiyor.',
        registrationFailed: 'Kayıt başarısız',
    },
    theme: {
        label: 'Tema',
        light: 'Açık',
        dark: 'Koyu',
        system: 'Sistem',
        switchToLight: 'Açık moda geç',
        switchToDark: 'Koyu moda geç',
    },
    connection: {
        Connected: 'Bağlı',
        Connecting: 'Bağlanıyor',
        Reconnecting: 'Yeniden bağlanıyor',
        Disconnected: 'Bağlantı kesildi',
        Error: 'Hata',
    },
    toolbar: {
        selectMovie: 'Film Seç',
        ai: 'AI',
        notifications: 'Bildirimler',
        loadingNotifications: 'Bildirimler yükleniyor...',
        noNotifications: 'Henüz bildirim yok.',
        zoom: 'Yakınlaştırma',
        zoomLevel: 'Yakınlaştırma seviyesi',
        zoomIn: 'Yakınlaştır',
        zoomOut: 'Uzaklaştır',
        zoomPercent: 'Yakınlaştırma %{percent}',
        shapes: 'Şekiller',
        objects3d: '3D nesneler',
        characters: 'Karakterler',
        characterPresets: {
            humanoid: 'İnsan',
            animal: 'Hayvan',
            turtle: 'Kaplumbağa',
            octopus: 'Ahtapot',
        },
        sceneEffects: 'Sahne efektleri',
        sceneEffectsLabel: 'Sahne Efektleri',
        activeEffects: '{count} aktif efekt',
        clearAllEffects: 'Tüm efektleri temizle',
        tools: {
            select: 'Seç (V)',
            pan: 'El (H, Space basılı tut)',
            line: 'Çizgi (L)',
            curve: 'Eğri (P)',
            text: 'Metin (T)',
            rectangle: 'Dikdörtgen (R)',
            circle: 'Daire (C)',
            triangle: 'Üçgen',
            polygon: 'Çokgen (G)',
            cube3d: '3D Küp',
            sphere3d: '3D Küre',
            box3d: '3D Kutu',
            cylinder3d: '3D Silindir',
            prism3d: '3D Prizma',
            mesh3d: '3D Mesh',
            fog: 'Sis',
            rain: 'Yağmur',
            snow: 'Kar',
            lightning: 'Şimşek',
            particles: 'Parçacıklar',
            vignette: 'Vinyet',
        },
    },
    movieSelector: {
        newMovie: 'Yeni Film',
        createNewMovie: 'Yeni Film Oluştur',
        movieNamePlaceholder: 'film adı...',
        movieDescriptionPlaceholder: 'film açıklaması...',
        recent: 'Son Açılanlar',
        myProjects: 'Projelerim',
        sampleMovies: 'Örnek Filmler',
        currentMovie: 'Geçerli Film',
        unloadMovie: 'Filmi Kapat',
        closeMovie: 'Filmi kapat',
        deleteMovie: 'Filmi Sil',
        moreActions: 'Diğer işlemler',
        selectToPreview: 'Önizlemek için bir film seçin',
        deleteConfirmTitle: 'Film silinsin mi?',
        deleteConfirmDescription: '"{name}" kalıcı olarak silinecek.',
        thisMovie: 'Bu film',
        movieAria: 'film',
        today: 'Bugün',
        yesterday: 'Dün',
        daysAgo: '{count} gün önce',
        older: 'Daha eski',
        errors: {
            idUnresolved: 'Film kimliği çözülemedi.',
            nameEmpty: 'Film adı boş olamaz.',
            saveFailed: 'Film kaydedilemedi. Lütfen tekrar deneyin.',
        },
    },
    userMenu: {
        ariaLabel: 'Kullanıcı menüsü',
        sectionsAria: 'Kullanıcı menüsü bölümleri',
        tabs: {
            credits: 'Krediler',
            account: 'Hesap',
            preferences: 'Tercihler',
        },
        administration: 'Yönetim',
        signOut: 'Çıkış Yap',
        loadingCredits: 'Krediler yükleniyor',
        creditsCount: '{count} kredi',
        credits: {
            currentBalance: 'Güncel Bakiye',
            unit: 'kredi',
            add: 'Kredi ekle',
            hideAdd: 'Kredi eklemeyi gizle',
            hideAddOptions: 'Kredi ekleme seçeneklerini gizle',
            loadingPurchase: 'Satın alma seçenekleri yükleniyor...',
            noCardOptions: 'Kartla ödeme seçeneği yapılandırılmamış.',
            planCredits: '{count} kredi',
            loadWithTether: 'Tether (USDT) ile yükle',
            loadingDeposit: 'Yükleniyor...',
            noUsdtWallet: 'USDT cüzdan adresi tanımlanmamış.',
            rate: '1 {symbol} = {credits} kredi',
            copyAddress: 'Adresi kopyala',
            recentTransactions: 'Son İşlemler',
            loadingTransactions: 'İşlemler yükleniyor...',
            noTransactions: 'Henüz işlem yok.',
        },
        account: {
            creditUsage: 'Kredi Kullanımı',
            balance: 'Bakiye',
            earned: 'Kazanılan',
            spent: 'Harcanan',
            transactions: 'İşlemler',
            changePassword: 'Şifre değiştir',
            changePasswordTitle: 'Şifre Değiştir',
            currentPassword: 'Mevcut şifre',
            currentPasswordHint: 'Yalnızca sosyal hesaplar için boş bırakın',
            newPassword: 'Yeni şifre',
            confirmPassword: 'Yeni şifreyi onayla',
            updatePassword: 'Şifreyi güncelle',
            saving: 'Kaydediliyor…',
            errors: {
                newRequired: 'Yeni şifre gerekli.',
                minLength: 'Yeni şifre en az 6 karakter olmalı.',
                mismatch: 'Yeni şifre ve onay eşleşmiyor.',
                failed: 'Şifre değiştirilemedi.',
            },
            success: 'Şifre başarıyla değiştirildi.',
        },
    },
    sidebar: {
        collapse: 'Paneli daralt',
        expand: 'Paneli genişlet',
    },
    toolpads: {
        library: {
            title: 'Kütüphane',
            dropImages: 'Görselleri buraya bırakın',
            importFiles: 'Dosya İçe Aktar',
            import: '+ İçe Aktar',
            importAria: 'Dosya içe aktar',
            uploading: 'Yükleniyor…',
            deleteConfirmTitle: 'Kütüphane öğesi silinsin mi?',
            deleteConfirmDescription: '"{name}" kalıcı olarak silinecek.',
            deleteFailedTitle: 'Silinemedi',
            deleteFailedFallback: 'Silinemedi.',
            inUseTitle: 'Kütüphane öğesi kullanılıyor',
            inUseDescription: '"{name}" en az bir sahne nesnesi tarafından kullanılıyor ({count} adet). Önce sahneden kaldırın.',
            noLayerTitle: 'Katman seçili değil',
            noLayerDescription: 'Sahne nesnesi eklemek için önce bir katman seçin.',
            mine: 'Proje',
            vectorHint: 'Sahneye sürükleyin veya çift tıklayın; dosya bu projeye kopyalanır.',
            vectorsEmpty: 'Herkese açık kütüphane boş.',
            vectorsLoadFailed: 'Herkese açık kütüphane yüklenemedi.',
            vectorUseFailed: 'Kütüphane öğesi projeye eklenemedi.',
        },
        scenes: {
            title: 'Sahneler',
            empty: 'Henüz sahne yok.',
            add: '+ Sahne Ekle',
            defaultName: 'Sahne {count}',
            nameAria: 'Sahne adı',
            dragReorder: 'Sıralamak için sürükle',
            deleteTitle: 'Sahneyi Sil',
            deleteDescription: '"{name}" silinecek.',
            deleteTooltip: 'Sahneyi Sil',
            cannotDeleteTitle: 'Sahne silinemez',
            cannotDeleteLast: "Filmde en az bir sahne kalmalı. Son sahne silinemez.",
            createFailed: 'Sahne oluşturulamadı: {error}',
            deleteFailed: 'Sahne silinemedi: {error}',
        },
        sceneObjects: {
            title: 'Sahne Nesneleri',
            empty: 'Kütüphaneden sürükleyerek sahneye nesne ekleyin.',
            selectAll: 'Tümünü seç',
            selectAllAria: 'Tüm sahne nesnelerini seç',
            selectedCount: '{count} seçili',
            expand: 'Genişlet',
            collapse: 'Daralt',
            objectNameAria: 'Nesne adı',
            selectObject: '{name} seç',
            selectObjectAndChildren: '{name} ve alt öğelerini seç',
            deselectObjectAndChildren: '{name} ve alt öğelerinin seçimini kaldır',
            selectAllChildren: 'Tüm alt öğeleri seç',
            all: 'Tümü',
        },
        sceneEffects: {
            title: 'Sahne Efektleri',
            empty: 'Parametrelerini buradan ayarlamak için araç çubuğundan sahne efektlerini açın.',
            activeCount: '{count} aktif',
            clearAll: 'Tümünü temizle',
            expand: 'Parametreleri aç',
            collapse: 'Parametreleri kapat',
            enable: 'Efekti aç',
            disable: 'Efekti kapat',
            params: {
                intensity: 'Yoğunluk',
                speed: 'Hız',
                particleSize: 'Parçacık boyutu',
                color: 'Renk',
            },
        },
        clipFolders: {
            title: 'Klip Klasörleri',
            empty: 'Klip klasörü yok.',
            add: '+ Klasör Ekle',
            defaultName: 'Klasör {count}',
            deleteTooltip: 'Klasörü Sil',
        },
        movieProperties: {
            title: 'Film Özellikleri',
            stageSize: 'Sahne Boyutu',
            width: 'G',
            height: 'Y',
            frameRate: 'Kare Hızı',
            frameRateAria: 'Kare hızı',
            fpsOption: '{count} FPS',
            info: 'Bilgi',
            name: 'Ad: ',
            scenes: 'Sahneler: ',
            noMovie: 'Yüklü film yok.',
            publish: 'Yayınla',
            publishing: 'Yayınlanıyor…',
            publishHint: 'Herkese açık oynatıcı için salt-okunur bir anlık görüntü oluşturur.',
            linkCopied: 'Oynatıcı bağlantısı kopyalandı.',
        },
    },
    rightSidebar: {
        style: {
            title: 'Stil',
            selectObject: 'Renk ayarlamak için sahnede bir obje seç.',
            shapeOrTextOnly: 'Stil ayarları şekil, metin ve görsel nesneleri için geçerlidir.',
            text: 'Metin',
            textColor: 'Metin Rengi',
            fontSize: 'Yazı Boyutu',
            fontSizeAria: 'Yazı boyutu',
            fontSizePxAria: 'Yazı boyutu px',
            align: 'Hizala',
            textAlignAria: 'Metin hizası',
            left: 'Sol',
            center: 'Orta',
            right: 'Sağ',
            justify: 'İki yana',
            colors: 'Renkler',
            fill: 'Dolgu',
            fillModeAria: 'Dolgu modu',
            fillSolid: 'Renk',
            fillGradient: 'Gradyan',
            fillColor: 'Dolgu Rengi',
            gradientStart: 'Başlangıç',
            gradientEnd: 'Bitiş',
            gradientAngle: 'Açı',
            gradientAngleAria: 'Gradyan açısı',
            border: 'Kenarlık',
            borderTypeAria: 'Kenarlık türü',
            borderColor: 'Kenarlık Rengi',
            borderSizeAria: 'Kenarlık boyutu',
            size: 'Boyut',
            sides: 'Kenarlar',
            sidesAria: 'Kenarlık kenarları',
            sideTop: 'Üst',
            sideRight: 'Sağ',
            sideBottom: 'Alt',
            sideLeft: 'Sol',
            solid: 'Düz',
            dashed: 'Kesik',
            dotted: 'Noktalı',
            fillBorderConflict: 'Fill ve border aynı anda none olamaz.',
            effects: 'Efektler',
            shadow: 'Gölge',
            shadowColor: 'Gölge rengi',
            shadowOffsetX: 'Kaydırma X',
            shadowOffsetY: 'Kaydırma Y',
            shadowBlur: 'Bulanıklık',
            shadowSpread: 'Yayılma',
            glow: 'Parıltı',
            glowColor: 'Parıltı rengi',
            glowBlur: 'Parıltı bulanıklığı',
            enabled: 'Açık',
            disabled: 'Kapalı',
        },
        properties: {
            title: 'Özellikler',
            object: 'Nesne',
            tween: 'Tween',
            transform: 'Dönüşüm',
            stageTools: 'Sahne araçları',
            stageResize: 'Resize',
            stageRotate: 'Rotate',
            stageResizeHint: 'Seçili nesnede resize handle’larını göster',
            stageRotateHint: 'Seçili nesnede köşe rotate handle’ları ve pivot’u göster',
            pivotHint: 'Döndürme pivot / eklem noktasını sürükleyerek ayarla',
            keepAspectRatio: 'En-boy oranını koru',
            keepAspectRatioHint: 'Resize sırasında Shift ile de geçici olarak etkinleşir.',
            appearance: 'Görünüm',
            rotation: 'Döndürme',
            rotationAria: 'Döndürme',
            rotationDegreesAria: 'Döndürme derecesi',
            opacity: 'Opaklık',
            opacityAria: 'Opaklık',
            opacityPercentAria: 'Opaklık yüzdesi',
            visibility: 'Görünürlük',
            activeTween: 'Aktif Tween ({start} → {end})',
            easing: 'Easing',
            easingAria: 'Easing türü',
            linear: 'Linear',
            easeIn: 'Ease In',
            easeOut: 'Ease Out',
            easeInOut: 'Ease In-Out',
            bounce: 'Bounce',
            elastic: 'Elastic',
            back: 'Back',
            noTween: 'Geçerli karede tween yok.',
            noTweenHint: 'İki keyframe oluşturup aralarına tween ekleyin.',
            allTweens: 'Tüm Tweenler',
            frameRange: 'Kare {start} → {end}',
            noSelection: 'Özellikleri görmek ve düzenlemek için Sahnede veya Timeline’da bir şey seçin.',
            selectedObjects: '{count} nesne seçili',
            selectedObjectAria: 'Seçimdeki düzenlenecek nesne',
            keyframe: 'Keyframe',
            frame: 'Kare:',
            activeKeyframe: '◆ Aktif Keyframe: Kare {frame}',
            noKeyframe: 'Geçerli karede veya öncesinde keyframe yok',
            selectFrameHint: 'Timeline’dan bir frame seç',
            createKeyframe: 'Keyframe Oluştur',
            updateKeyframe: 'Keyframe Güncelle',
            stateObjects: 'State taşıyan nesneler',
            noStateObjects: 'Bu keyframe nesne state’i taşımıyor.',
            copyStateToPrevious: 'Önceki keyframe’e kopyala ({frame})',
            copyStateToNext: 'Sonraki keyframe’e kopyala ({frame})',
            noPreviousKeyframe: 'Önceki keyframe yok',
            noNextKeyframe: 'Sonraki keyframe yok',
        },
        align: {
            title: 'Hizala',
            horizontal: 'Yatay',
            vertical: 'Dikey',
            left: 'Sola Hizala',
            center: 'Ortala',
            right: 'Sağa Hizala',
            top: 'Yukarı Hizala',
            middle: 'Orta Hizala',
            bottom: 'Aşağı Hizala',
        },
    },
    timeline: {
        prevFrame: 'Önceki Kare (,)',
        pause: 'Duraklat (Space)',
        play: 'Oynat (Space)',
        playNeedsKeyframe: 'Oynatmak için en az bir keyframe gerekir',
        stop: 'Durdur (.)',
        nextFrame: 'Sonraki Kare (.)',
        addKeyframe: 'Keyframe Ekle (F6)',
        deselectKeyframe: 'Playhead’e eklemek için keyframe seçimini kaldır',
        keyframeExists: 'Geçerli karede zaten keyframe var',
        deleteKeyframe: 'Keyframe Sil',
        addTween: 'Tween Ekle (F7)',
        addTweenHint: 'İki keyframe arasında, tween yokken eklenebilir',
        deleteTween: 'Tween Sil',
        frame: 'Kare:',
        time: 'Zaman:',
        total: 'Toplam:',
        totalFramesAria: 'Toplam kare',
        addLayer: 'Katman Ekle',
        newLayer: 'Yeni katman',
        dragReorder: 'Sıralamak için sürükle',
        deleteLayer: 'Katmanı Sil',
        cannotDeleteTitle: 'Katman silinemez',
        cannotDeleteLast: 'Sahnede en az bir katman kalmalı. Son katman silinemez.',
        cannotDeleteNonEmpty: 'Bu katman boş değil. Silmeden önce keyframe, tween ve sahne nesnesi kayıtlarını temizle.',
        tweenTitle: 'Tween: {start} - {end} ({easing})',
        frameTitle: 'Kare {frame}',
        frameDeleting: 'Kare {frame} (siliniyor...)',
        addKeyframeAt: 'Keyframe Ekle (Kare {frame})',
        addTweenShort: 'Tween Ekle',
        clearAllKeyframes: 'Tüm Keyframeleri Temizle',
        clearAllTweens: 'Tüm Tweenleri Temizle',
    },
    stage: {
        selectionToolbar: 'Nesne eylemleri',
        duplicate: 'Çoğalt',
        createGroup: 'Grup Oluştur',
        createPattern: 'Desen Oluştur',
        ungroup: 'Grubu Çöz',
        removeFromGroup: 'Gruptan Çıkar',
        groupName: 'Grup',
        insideThisLayer: 'Bu katman içinde',
        bringToFront: 'En Öne Getir',
        bringForward: 'Öne Getir',
        sendBackward: 'Geri Gönder',
        sendToBack: 'En Geriye Gönder',
        sendToLayer: 'Katmana gönder',
        sendInto: 'İçine gönder',
        noSendIntoTargets: 'Bu katmanda başka nesne yok',
        objectFallback: 'Nesne {id}',
        noLayers: 'Katman yok',
        layerFallback: 'Katman {id}',
        noLayerTitle: 'Katman seçili değil',
        noLayerDescription: 'Sahne nesnesi eklemek için önce bir katman seçin.',
    },
    welcome: {
        title: 'Hoş geldiniz',
        subtitle: 'Yeni bir proje oluşturabilir veya son kullanılan bir projeyi seçebilirsiniz.',
        createProject: 'Yeni Proje Oluştur',
        projectNamePlaceholder: 'Proje adı...',
        recentlyUsed: 'Son Kullanılanlar',
        noRecent: 'Son kullanılan proje yok',
        myProjects: 'Projelerim',
        sampleProjects: 'Örnek Projeler',
        empty: 'Henüz proje yok. Yeni bir proje oluşturarak başlayın!',
        movieAria: 'film',
        previewTitle: 'Önizleme',
        openProject: 'Projeyi Aç',
        noDescription: 'Açıklama yok',
        resolution: 'Çözünürlük',
        fps: 'Kare hızı',
        fpsValue: '{fps} fps',
        scenes: 'Sahneler',
        sceneObjects: 'Sahne nesneleri',
        layers: 'Katmanlar',
        sampleBadge: 'Örnek',
    },
    aiChat: {
        deleteMessage: 'Mesajı sil',
        thinking: 'Düşünüyor...',
        jobs: 'İşler',
        actions: 'Aksiyonlar',
        payloads: 'Payloadlar',
        executionResults: 'Çalıştırma Sonuçları',
        loading: 'Yükleniyor...',
        resizePanel: 'Sohbet panelini yeniden boyutlandır',
        selectConversation: 'Konuşma seç',
        newChat: 'Yeni Sohbet',
        newChatTooltip: 'Yeni sohbet',
        deleteConversation: 'Konuşmayı sil',
        debugOn: 'Debug modu açık',
        debugOff: 'Debug modu kapalı',
        placeholder: 'Bir sahne tarif edin ...',
        send: 'Gönder',
    },
    admin: {
        badge: 'Admin',
        backToEditor: 'Editöre Dön',
        topbarTitle: 'Admin',
        a11y: {
            closeNav: 'Navigasyonu kapat',
            openNav: 'Navigasyonu aç',
        },
        nav: {
            dashboard: 'Kontrol Paneli',
            users: 'Kullanıcılar',
            projects: 'Projeler',
            activity: 'Etkinlik',
            activityDesc: 'SignalR · günlük',
            activityTitle: 'Canlı SignalR bağlantıları ve etkinlik günlüğü',
            storageProviders: 'Depolama Sağlayıcıları',
            socialProviders: 'Social Login',
            ai: 'AI',
            providers: 'Sağlayıcılar',
            prompts: 'Promptlar',
            payment: 'Ödeme',
            cryptoWallets: 'Kripto Cüzdanları',
            disclaimers: 'Disclaimers',
            install: 'Kurulum',
            analytics: 'Analitik',
            settings: 'Ayarlar',
            vectorPackages: 'Herkese Açık Kütüphane',
        },
        vectorPackages: {
            title: 'Herkese Açık Kütüphane',
            description: 'Platformun her projeyle paylaştığı kütüphane. Git deposu içe aktarın veya zip yükleyin. Her klasör ayrı bir paket olur.',
            name: 'Paket adı',
            file: 'Paket dosyası',
            fileHint: 'Zip, SVG, PNG, WebP veya JPEG. Zip içeriği tek tek dosyalara ayrılır.',
            upload: 'Paketi yükle',
            uploading: 'Yükleniyor…',
            empty: 'Herkese açık kütüphane boş.',
            files: '{count} dosya',
            delete: 'Sil',
            preview: 'Dosyalar',
            hide: 'Gizle',
            deleteConfirm: '"{name}" ve dosyaları silinsin mi?',
            uploadFailed: 'Yükleme başarısız.',
            deleteFailed: 'Paket silinemedi.',
            nameRequired: 'Paket adı gerekli.',
            fileRequired: 'Bir paket dosyası seçin.',
            loadFailed: 'Herkese açık kütüphane yüklenemedi.',
            gitUrl: 'Depo adresi',
            gitBranch: 'Dal',
            gitPath: 'Klasör',
            gitFormat: 'Biçim',
            formatSvg: 'SVG',
            formatPng: 'PNG',
            gitHint: 'Yalnızca HTTPS. kits gibi bir klasör, her alt klasör için bir paket oluşturur. SVG ve PNG birlikte alınmaz. Aynı depoyu yeniden aktarmak paketleri günceller.',
            gitImport: 'Depoyu içe aktar',
            gitImporting: 'İçe aktarılıyor…',
            gitImported: '{count} paket içe aktarıldı.',
            gitFailed: 'Depo içe aktarılamadı.',
            gitUrlRequired: 'Depo adresi gerekli.',
        },
    },
};
